
export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        offset: {
            type: Number,
            default: 0
        },
        showDisabled: {
            type: Boolean,
            default: false
        },
        paginationClass: {
            type: String
        },
        filterQuery: {
            type: String
        }
    },

    head() {
        return {
            link: this.headLinks()
        }
    },

    computed: {
        isApiResource () {
            return !!this.data.meta;
        },
        path () {
            return this.isApiResource ? this.data.meta.path : this.data.path;
        },
        currentPage () {
            return this.isApiResource ? this.data.meta.current_page : this.data.current_page;
        },
        firstPageUrl () {
            return this.isApiResource ? this.data.links.first : null;
        },
        from () {
            return this.isApiResource ? this.data.meta.from : this.data.from;
        },
        lastPage () {
            return this.isApiResource ? this.data.meta.last_page : this.data.last_page;
        },
        lastPageUrl () {
            return this.isApiResource ? this.data.links.last : null;
        },
        nextPageUrl () {
            return this.isApiResource ? this.data.links.next : this.data.next_page_url;
        },
        perPage () {
            return this.isApiResource ? this.data.meta.per_page : this.data.per_page;
        },
        prevPageUrl () {
            return this.isApiResource ? this.data.links.prev : this.data.prev_page_url;
        },
        to () {
            return this.isApiResource ? this.data.meta.to : this.data.to;
        },
        total () {
            return this.isApiResource ? this.data.meta.total : this.data.total;
        },
        pageRange () {
            if (this.offset === -1) {
                return 0;
            }

            if (this.offset === 0) {
                return this.lastPage;
            }

            var current = this.currentPage;
            var last = this.lastPage;
            var delta = this.offset;
            var left = current - delta;
            var right = current + delta + 1;
            var range = [];
            var pages = [];
            var l;

            if(left < 0) {
                left = 0
            }

            if(right < (delta*3+1)) {
                right = delta*2+3
            }

            if(right > last) {
                right = last
            }

            if( (right - left) <= (delta*2+1) ) {
                left = right - (delta*2+1)
            }

            for (var i = 1; i <= last; i++) {
                if (i === 1 || i === last || (i >= left && i < right)) {
                    range.push(i);
                }
            }

            range.forEach(function (i) {
                if (l) {
                    if (i - l === 2) {
                       //pages.push(l + 1);
                        pages.push('...');
                    } else if (i - l !== 1) {
                        pages.push('...');
                    }
                }
                pages.push(i);
                l = i;
            });

            return pages;
        }
    },

    methods: {
        previousPage () {
            this.selectPage((this.currentPage - 1));
        },
        nextPage () {
            this.selectPage((this.currentPage + 1));
        },
        selectPage (page) {
            if (page === '...') {
                return;
            }

            this.$emit('pagination-change-page', page);
        },

        addFilterQuery(pagePath) {

            if(this.filterQuery) {
                pagePath = pagePath + '?filter=' + this.filterQuery
            }

            return pagePath

        },

        replaceRoute(url) {

            if(!url) {
                return ''
            }

            return url.replace('?', '/').replace('=', '/')
        },

        getPageUrl(page) {

            var pagePath;

            if(page === 1) {
                pagePath = this.path
            } else {
                pagePath = this.path + '/page/' + page
            }

            return this.addFilterQuery(pagePath)
        },

        getPreviousPageUrl() {

            var pagePath;

            if(this.prevPageUrl === this.firstPageUrl) {
                pagePath = this.path;
            } else {
                pagePath = this.replaceRoute(this.prevPageUrl);
            }

            return this.addFilterQuery(pagePath)
        },

        getNextPageUrl() {

            var pagePath;

            pagePath = this.replaceRoute(this.nextPageUrl);

            return this.addFilterQuery(pagePath)
        },

        headLinks() {

            let links = [];

            if(this.prevPageUrl) {
                var prev = { rel: 'prev', href: this.getPreviousPageUrl() }
                links.push(prev)
            }

            if(this.nextPageUrl) {
                var next = { rel: 'next', href: this.getNextPageUrl() }
                links.push(next)
            }

            return links

        },
    },

    render () {
        return this.$scopedSlots.default({
            data: this.data,
            offset: this.offset,
            showDisabled: this.showDisabled,
            computed: {
                isApiResource: this.isApiResource,
                currentPage: this.currentPage,
                firstPageUrl: this.firstPageUrl,
                from: this.from,
                lastPage: this.lastPage,
                lastPageUrl: this.lastPageUrl,
                nextPageUrl: this.nextPageUrl,
                perPage: this.perPage,
                prevPageUrl: this.prevPageUrl,
                to: this.to,
                total: this.total,
                pageRange: this.pageRange
            },
            prevButtonEvents: {
                click: (e) => {
                    e.preventDefault();
                    this.previousPage();
                }
            },
            nextButtonEvents: {
                click: (e) => {
                    e.preventDefault();
                    this.nextPage();
                }
            },
            pageButtonEvents: page => ({
                click: (e) => {
                    e.preventDefault();
                    this.selectPage(page);
                }
            }),
            getPageUrl: page => this.getPageUrl(page),
            getPreviousPageUrl: this.getPreviousPageUrl(),
            getNextPageUrl: this.getNextPageUrl(),
        });
    }
}
